// DropCell.js - スマホ対応改善版
import React from 'react';
import { useDrop } from 'react-dnd';

const DropCell = ({ room, currentTime, onDrop, className }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: 'surgery',
    drop: (item) => {
      onDrop(item);
      // ドロップ成功時のバイブレーション（対応デバイスのみ）
      if (navigator.vibrate) {
        navigator.vibrate([100, 50, 100]);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  // ドロップ可能状態のスタイル
  const dropStyle = {
    backgroundColor: isOver && canDrop ? 'rgba(59, 130, 246, 0.2)' : 'transparent',
    border: isOver && canDrop ? '2px dashed rgba(59, 130, 246, 0.5)' : 'none',
    borderRadius: isOver && canDrop ? '4px' : '0',
    transition: 'all 0.2s ease',
    minHeight: '48px', // タッチ対応の最小サイズ
    position: 'relative',
  };

  return (
    <div
      ref={drop}
      className={`${className || ''} ${isOver && canDrop ? 'drop-cell-hover' : ''}`}
      style={dropStyle}
    >
      {/* ドロップ可能状態のインジケーター */}
      {isOver && canDrop && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="text-blue-500 font-medium text-sm opacity-75">
            ここにドロップ
          </div>
        </div>
      )}
    </div>
  );
};

export default DropCell;